import React from "react";
import { Dialog, Card, Typography, Grid, Button } from "@mui/material";

const GeneralModal = ({
  open,
  title = "Mensaje",
  message = "",
  withBtnAction = false,
  onClickAction,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <Card
        sx={{
          padding: 3,
          minWidth: 350,
          maxWidth: 500,
          mx: "auto", // centra horizontal
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          {title}
        </Typography>

        <Typography variant="body1" color="gray" sx={{ mt: 2 }}>
          {message}
        </Typography>

        <Grid container spacing={2} justifyContent="center" sx={{ mt: 3 }}>
          <Grid item>
            {withBtnAction ? (
              <Button
                variant="contained"
                onClick={onClickAction}
                sx={{
                  backgroundColor: "#4caf50", // verde
                  "&:hover": {
                    backgroundColor: "#388e3c", // verde más oscuro
                  },
                }}
              >
                Continuar
              </Button>
            ) : (
              ""
            )}
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "red",
                "&:hover": {
                  backgroundColor: "#ff6666",
                },
              }}
              onClick={onClose}
            >
              Cerrar
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Dialog>
  );
};

export default GeneralModal;
